<template>
  <div>
    <slot v-if="variantKey === 'A'" name="A" />
    <slot v-if="variantKey === 'B'" name="B" />
  </div>
</template>

<script setup lang="ts">
import experimentsConfig from '@/config/experiments'

const props = defineProps({
  experimentCode: { type: String, required: true },
  defaultVariant: { type: String, required: false, default: 'A' },
})

const experimentsStore = useExperimentsStore()
const setupGtmABTestEvent = useSetupGtmABTestEvent()

const variantKey = computed(() => {
  // `experimentCode` can be empty string, forcing the default.
  if (!props.experimentCode) {
    return props.defaultVariant
  }
  const experimentConfig = experimentsConfig.activeExperiments[props.experimentCode]
  const experiment = experimentsStore.experiments[props.experimentCode]
  const variant = experiment?.variant
  const key = experimentConfig && Object.keys(experimentConfig.variants).find((k) => experimentConfig.variants[k as keyof typeof experimentConfig.variants] === variant)
  return key ?? props.defaultVariant
})

if (props.experimentCode) {
  setupVariantDetection(props.experimentCode)

  // Watch a *getter* (not a ref): Vue re-runs this function to collect reactive deps (here: the
  // experiments store state), compares the returned string to the previous return, and runs the
  // callback when it changes—e.g. variant goes null → "cv10 - V2" after cookie detection.
  watch(
    () => {
      const experiment = experimentsStore.experiments[props.experimentCode]
      if (!experiment?.variant) {
        return null
      }
      const experimentConfig = experimentsConfig.activeExperiments[props.experimentCode]
      const key =
        experimentConfig && Object.keys(experimentConfig.variants).find((k) => experimentConfig.variants[k as keyof typeof experimentConfig.variants] === experiment.variant)
      return key ? `${props.experimentCode} - ${experiment.variant}` : null
    },
    (experimentCodeVariantLabel) => {
      if (experimentCodeVariantLabel !== null) {
        setupGtmABTestEvent(experimentCodeVariantLabel)
      }
    },
    { immediate: true },
  )
}
</script>

<style scoped lang="scss"></style>
